import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import Blogs from '../blogs';
import { compose } from '../../utils/helpers';
import { mapPageSlug, mapToCardItem } from '../../utils/mappers';

const RecentBlogList = ({ headline, subheading }) => {
	const { latestBlogDetails } = useStaticQuery(graphql`
		query {
			latestBlogDetails: allContentfulPageBlogNewsDetail(
				sort: { fields: date, order: DESC }
				limit: 3
				filter: { type: { eq: "Blog" } }
			) {
				edges {
					node {
						...BlogNewsCardFields
					}
				}
			}
		}
	`);
	const items = latestBlogDetails?.edges?.map(compose(mapPageSlug, mapToCardItem));

	return <Blogs headline={headline} subheading={subheading} items={items} />;
};

RecentBlogList.propTypes = {
	headline: PropTypes.string,
	subheading: PropTypes.shape({
		childMarkdownRemark: PropTypes.shape({ htmlAst: PropTypes.object }),
	}),
};

RecentBlogList.defaultProps = {
	subheading: {},
};

export default RecentBlogList;
